<template>
  <form class="form-horizontal">
    <card>
      <div slot="header">
        <h4 class="card-title">{{ crud }} Visual da telas das máquinas </h4>
      </div>
      <div>
        <fg-input name="Nome" label="Nome" v-model="model.name"></fg-input>

        <fg-input v-if="showMatriz" name="company" label="Filial">
          <el-select
            class
            size="large"
            style="width: 100%"
            placeholder="Selecione a filial"
            v-model="model.company"
          >
            <el-option
              v-for="option in companyList"
              class
              :value="option.id"
              :label="option.name"
              :key="option.id"
            ></el-option>
          </el-select>
        </fg-input>
        
        <fg-input
          v-if="showMatriz"
          name="select_vms"
          label="Máquinas e Lockers">
       
          <el-select
            class="select-default"
            size="large"
            multiple
            style="width: 100%"
            placeholder="Seleciones as máquinas e lockers"
            v-model="model.vms"
          >
            <el-option
              v-for="option in filial"
              class="select-info"
              :value="option.id"
              :label="option.location"
              :key="option.id"
            ></el-option>
          </el-select>
        </fg-input>

        
        <fg-input
          v-if="!showMatriz"
          name="select_vms"
          label="Máquinas e Lockers">
       
          <el-select
            class="select-default"
            size="large"
            multiple
            style="width: 100%"
            placeholder="Seleciones as máquinas e lockers"
            v-model="model.vms"
          >
            <el-option
              v-for="option in machines[0]"
              class="select-info"
              :value="option.id"
              :label="option.location"
              :key="option.id"
            ></el-option>
          </el-select>
        </fg-input>

          <div class="block">
          <span style="margin-top: -15px">Cor da fonte : </span>
          <el-color-picker  size="small" v-model="model.font_color"></el-color-picker>
          <span style="margin-left: 15px">{{model.font_color}}</span>
        </div>
        
          <div class="block">
          <span style="margin-top: -15px">Cor do background : </span>
          <el-color-picker size="small" v-model="model.background_color"></el-color-picker>
          <span style="margin-left: 15px">{{model.background_color}}</span>
        </div>
        <div style="height: 15px"></div>

        <div class="block">
          <span class="demonstration">Posição vertical (%): </span>
          <el-slider v-model="model.vertical_position"></el-slider>
        </div>


        <div class="block">
          <span class="demonstration">Posição horizontal (%):</span>
          <el-slider v-model="model.horizontal_position"></el-slider>
        </div>

        <fg-input
          name="select_vms"
          label="Imagem do Logo">
          <a
              style="font-size: 1.2em"
              class="btn btn-info btn-link "
              @click="$refs.SelectImage.click()"
            >
              <i  class="nc-icon nc-album-2 "></i>
          </a>
          <a
              style="font-size: 1.2em; margin-left: -10px"
              class="btn btn-info btn-link "
              @click="aviso1()"
            >
              <i  class="fa fa-question-circle-o "></i>
          </a>
        <img :src="model.logo" alt="logo" height="40%" width="40%" v-if="showImage">

            <input
              name="image"
              style="display: none"
              label="Image"
              type="file"
              ref="SelectImage"
              accept="image/*"
              @change="onChange"
              class="col-sm-12"
            >

        </fg-input>


        <fg-input
          name="select_vms"
          label="Imagem do Background">
          <a
              style="font-size: 1.2em"
              class="btn btn-info btn-link "
              @click="$refs.SelectImage2.click()"
            >
              <i  class="nc-icon nc-album-2 "></i>
          </a>
          <a
              style="font-size: 1.2em; margin-left: -10px"
              class="btn btn-info btn-link "
              @click="aviso2()"
            >
              <i  class="fa fa-question-circle-o "></i>
          </a>
        <img :src="model.background" alt="logo" height="40%" width="40%" v-if="showImage2">

            <input
              name="image"
              style="display: none"
              label="Image"
              type="file"
              ref="SelectImage2"
              accept="image/*"
              @change="onChange2"
              class="col-sm-12"
            >

        </fg-input>
        <div style="height: 30px"></div>
        <button type="submit" @click.prevent="previewDialog = true" class="btn btn-fill btn-info btn-wd">Preview</button>

        <el-dialog
          title="Preview"
          style="font-color: red"
          :visible.sync="previewDialog"
          width="288px">
          <div style="height: 512px">

          <div
            v-if="model.background"
            :style="{ backgroundImage: 'url('+model.background+')',
            border: 'solid',
            color: 'black',
            height: '100%',
            width: '100%',
            position: 'relative',
            backgroundPposition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundSize: '100% 100%',}">
          <img :src="model.logo" 
                alt="logopreview"
                v-if="model.logo"
                :style="{position: 'absolute',
                        top: model.vertical_position - 2 +'%',
                        left: model.horizontal_position- 7 +'%',
                        width: '40%',
                        height: '40%'}"
          >
          </div>
          <div
            v-if="!model.background"
            :style="{ background: model.background_color,
            border: 'solid',
            color: 'black',
            height: '100%',
            width: '100%',
            position: 'relative',}">
          <img :src="model.logo" 
                v-if="model.logo"
                alt="logopreview"
                :style="{position: 'absolute',
                        top: model.vertical_position+'%',
                        left: model.horizontal_position+'%',
                        width: '40%',
                        height: '40%'}"
          >
          </div>

          </div>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="previewDialog = false">Fechar</el-button>
          </span>
        </el-dialog>

      </div>
    </card>
    <card>
      <div>
        <el-button type="success" :loading="btnLoading" 
          @click.prevent="validate">Salvar</el-button>
      </div>
    </card>
  </form>
</template>
<script>
import { Select, Option, Checkbox,ColorPicker, Slider, Dialog, Button, Loading } from "element-ui";
import swal from "sweetalert2";

export default {
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    [Checkbox.name]: Checkbox,
    [ColorPicker.name]: ColorPicker,
    [Slider.name]: Slider,
    [Dialog.name]: Dialog,
    [Button.name]: Button,
  },
  mounted() {
    // this.$store.dispatch("sales/list")
    this.getListCompany()
    if (this.$route.params.id) {
      this.$store.dispatch("visual/get", {id: this.$route.params.id}).then(data => {
        this.model = data
        this.model.vertical_position = Number(data.vertical_position)
        this.model.horizontal_position = Number(data.horizontal_position)
        console.log('logo', this.model )
        if (this.model.background !== null && this.model.background.slice(0,4) === 'http') {
          this.showImage2 = true
        }
        if (this.model.logo !== null && this.model.logo.slice(0,4) === 'http') {
          this.showImage = true
        }
      });
      this.crud = "Editar";
    } else {
      this.crud = "Criar";
    }
    this.machines.push(this.$store.state.machines.machines)
    const ciaID = localStorage.getItem('smartmachCiaID')
    if (ciaID) {
      this.model.company = Number(ciaID)
    }
    // for (let index = 0; index < this.$store.state.lockers.lockers.length; index++) {
    //   this.machines[0].push(this.$store.state.lockers.lockers[index])
      
    // }
    console.log('maichiens', this.machines)
    if (this.showMatriz) {
      this.$watch('model.company', ()=>{
        this.selectFilial()
      })
    }
  },
  computed: {
    sales() {
      return this.$store.state.sales.sales;
    },
    showMatriz () {
      const matriz = localStorage.getItem("parent_company")
      if (matriz != 'null') {
        return true
      } else {
        return false
      }
    },
  },
  data() {
    return {
      crud: "Editar",
      machines: [],
      showImage: false,
      showImage2: false,
      previewDialog: false,
      btnLoading: false,
      companyList: [],
      filial: [],
      model: {
        name: '',

      },
      modelValidations: {
        name: {
          required: true
        }
      }
    };
  },
  methods: {
    localeDate(date) {
      const d = new Date(date);
      return d.toLocaleString("pt-BR");
    },
    selectFilial () {
      this.filial = []
      this.machines[0].forEach(el => {
        if (el.company == this.model.company) {
          this.filial.push(el)
        }
      });
      console.log('filais', this.filial )
    },
    getListCompany () {
      this.$store.dispatch("company/list").then(resp => {
        this.companyList = resp.sort((a,b) => (a.name > b.name) ? 1 : (b.name > a.name) ? -1 : 0)
    
      })
    },
    notifySuccess() {
      this.$notify({
        message: "Sucesso</br>Item Salvo!",
        icon: "nc-icon nc-app",
        horizontalAlign: "right",
        verticalAlign: "bottom",
        type: "success"
      });
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    aviso1() {
      swal.fire({
        title: "Informação",
        text: `A tela da máquina possui a resolução de 720x1280. A visualização do preview possui uma escala de 40%
                  da resolução original. As posições selecionada anteriormente servem para posicionar a imagem do Logo na 
                  tela. Nota-se que o ponto de referência da imagem é o canto superior esquerdo. Portanto, a partir de um 
                  valor setado nos campos de posição, a imagem do logo poderá ficar fora da visualização da tela da máquina.`,
        icon: "warning",
        showCancelButton: false,
        confirmButtonClass: "btn btn-success btn-fill",
        confirmButtonText: "OK!",
        buttonsStyling: false
      })
    },
    aviso2() {
      swal.fire({
        title: "Informação",
        text: `A tela da máquina possui a resolução de 720x1280. Favor utilizar essa resolução na imagem de 
              background. Caso utilize imagem com proporções diferentes da máquina, poderá haver deformação da 
              imagem. Quando não houver imagem de background, a cor padrão selecionada anteriormente será 
              utilizada no lugar.`,
        icon: "warning",
        showCancelButton: false,
        confirmButtonClass: "btn btn-success btn-fill",
        confirmButtonText: "OK!",
        buttonsStyling: false
      })
    },
    validate() {
      // console.log('valod', this.model)
      this.$validator.validateAll().then(isValid => {
        this.btnLoading = true
        if (isValid && this.crud === "Criar") {
          this.$store
            .dispatch("visual/create", { item: this.model })
            .then(() => {
              this.btnLoading = false
              this.notifySuccess();
              this.$router.push(`/app/visuais`);
            });
        } else if (isValid && this.crud === "Editar") {
          console.log('model.logo', this.model.logo)
          console.log('model.bac', this.model.background)
          if (this.model.logo != null) {
            if (this.model.logo.slice(0,4) === 'http') {
              delete this.model.logo
            } 
          }
          if (this.model.background != null) {
            if (this.model.background.slice(0,4) === 'http') {
              delete this.model.background
            }
          }
          this.$store
            .dispatch("visual/update", { item: this.model })
            .then(() => {
              this.btnLoading = false
              this.notifySuccess();
              this.$router.push(`/app/visuais`);
            });
        }
      });
    },
    analiseImage (data) {
      return new Promise(resolve => {
      var _URL = window.URL || window.webkitURL;
          var img = new Image();
          let self = this
          img.onload = function() {
            if (this.height >= 2000) {
              self.modal = true
              resolve (false)
            } else {
              resolve (true)
            }
          }
          img.onerror = function() {
            alert( "Imagem inválida: " + data.type);
          }
          img.src = _URL.createObjectURL(data);
        })
      },
    onChange(event) {
      this.showImage = false
      for (let i of event.target.files) {
        // MEDIDNDO A IMAGEM
        this.analiseImage(i).then(resp => {
          console.log('resposta da analise',resp)
          // CONTROLE DE TAMANHO
          if (resp) {
            if (i.size > 20971520) {
            this.text = 'Arquivo muito grande, tamanho máximo permitido é de 20 Mb.'
            this.color = 'error'
            this.snackbar = true
            }  else if (i.type.substr(6) === 'bmp' || i.type.substr(6) === 'tiff') {
            this.text = 'Formato inválido.'
            this.color = 'error'
            this.snackbar = true
            }
            else {
              console.log('auqi')
              const reader = new FileReader();
              reader.onload = e => {
                const image = e.target.result;
                console.log('aqwueoij')
                this.model.logo =  image ;
                this.showImage = true
              };
              reader.readAsDataURL(i);
            }
          }
        })
      }
    },
    analiseImage2 (data) {
      return new Promise(resolve => {
      var _URL = window.URL || window.webkitURL;
          var img = new Image();
          let self = this
          img.onload = function() {
            if (this.height >= 2000) {
              self.modal = true
              resolve (false)
            } else {
              resolve (true)
            }
          }
          img.onerror = function() {
            alert( "Imagem inválida: " + data.type);
          }
          img.src = _URL.createObjectURL(data);
        })
      },
    onChange2(event) {
      this.showImage2 = false
      for (let i of event.target.files) {
        // MEDIDNDO A IMAGEM
        this.analiseImage2(i).then(resp => {
          console.log('resposta da analise',resp)
          // CONTROLE DE TAMANHO
          if (resp) {
            if (i.size > 20971520) {
            this.text = 'Arquivo muito grande, tamanho máximo permitido é de 20 Mb.'
            this.color = 'error'
            this.snackbar = true
            }  else if (i.type.substr(6) === 'bmp' || i.type.substr(6) === 'tiff') {
            this.text = 'Formato inválido.'
            this.color = 'error'
            this.snackbar = true
            }
            else {
              const reader = new FileReader();
              reader.onload = e => {
                const image = e.target.result;
                this.model.background =  image ;
                this.showImage2 = true
              };
              reader.readAsDataURL(i);
            }
          }
        })
      }
    },
  }
};
</script>
<style scoped>
.el-select {
  margin-bottom: 10px;
}
.el-color-picker {
  margin-left: 10px;
}
img {
  width: 200px;
}
.img-upload {
  border: 1px solid #ccc;
  border-radius: 5px;
  display: inline-block;
  padding: 10px;
  margin-bottom: 20px;
}
</style>
